const bagCountEl = document.querySelector("#na-bag__open .item-count");

async function updateBagCount() {
  const { data } = await axios.get(window.Shopify.routes.root + "cart.js");
  const itemCount = data.item_count;
  bagCountEl.innerText = itemCount > 99 ? "99+" : itemCount;
}

async function addToBag(id, quantity, box_id) {
  const items = [{ id, quantity }];
  if (box_id) {
    items.push({ id: box_id, quantity: 1 });
  }
  await axios.post(window.Shopify.routes.root + "cart/add.js", { items });
  await updateBagCount();
}

function setupCardEvents() {
  const cardEls = document.querySelectorAll(".na-card");

  cardEls.forEach((cardEl) => {
    const { pid, title } = cardEl.dataset;
    const btn = cardEl.querySelector(".na-card__addbag");

    btn.addEventListener("click", () => {
      addToBag(pid, 1).then(() =>
        triggerPopup({ message: title + " Added to Cart", status: "tick" })
      ).catch(err => {
        triggerPopup({ message: err.response.data.message, status: "cross" })
      });
    });
  });
}

setupCardEvents();
